module.exports = __webpack_public_path__ + "static/media/Standing_Left_Hand.7264fb9d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/position_icons/Standing_Left_Hand.svg
// module id = 758
// module chunks = 0